let API_BASE_URL = "";

if (window.location.hostname.includes("programari.mariabeatrice.ro")) {
  API_BASE_URL = "https://api.mariabeatrice.ro";
} else {
  // fallback pentru local
  API_BASE_URL = "http://localhost:8000";
}

export default API_BASE_URL;